import request from '@/utils/request';
import router from '@/router';
import Vue from 'vue';

export default {
    requestReportCreate: async({ dispatch }, data) => {
        await request({ method: 'post', url: '/request', data })
            .then(res => {
                if (res.data && res.data.success) {
                    router.push('/photo-report/reports');
                    dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'createdPhotoRequest',
                        params: [res.data.success]
                    }, { root: true });
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    requestReportValidate: async({ dispatch }, data) => {
        return await request({ method: 'post', url: '/request/check', data})
            .then(res => {
                if (res.data.checkCallSign) {
                    dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'foundCallSign'
                    }, { root: true });
                } else {
                    dispatch('alert/addMessage', {
                        message: 'notFoundCallSign'
                    }, { root: true });
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    requestReportCheck: async({ dispatch, commit }, data) => {
        return await request({ method: 'post', url: '/request/check', data })
            .then(res => {
                commit('SET_DRIVERS', res.data);
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getActivePhotoReports: async({ dispatch, commit }, params) => {
        return await request({ method: 'get', url: '/request', params })
            .then(res => {
                if (res.data && res.data.items) {
                    commit('SET_PHOTO_REPORTS', res.data.items);
                    commit('SET_PAGINATION_ACTIVE', { page: res.data.page, totalPages: res.data.totalPages });
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getFinishedPhotoReports: async({ dispatch, commit }, params) => {
        return await request({ method: 'get', url: '/request', params })
            .then(res => {
                if (res.data && res.data.items) {
                    commit('SET_FINISHED_PHOTO_REPORTS', res.data.items);
                    commit('SET_PAGINATION_FINISHED', { page: res.data.page, totalPages: res.data.totalPages });
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    removePhotoReport: async({ dispatch, commit }, photoReportId) => {
        return await request({ method: 'delete', url: `/request/${photoReportId}` })
            .then(res => {
                commit('REMOVE_PHOTO_REPORT', res.data.id);

                dispatch('alert/addMessage', {
                    type: 'success',
                    message: 'success'
                }, { root: true });
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    editPhotoReport: async({ dispatch, commit }, data) => {
        return await request({ method: 'put', url: `/request/${data.id}`, data: data.formData})
            .then((res) => {
                if (res && res.data) {
                    commit('SET_REQUEST', res.data);
                    dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'success'
                    }, { root: true });
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    changeActivity: async({ dispatch }, requestId) => {
        return await request({ method: 'patch', url: `/request/${requestId}`})
            .then(() => {
                dispatch('alert/addMessage', {
                    type: 'success',
                    message: 'success'
                }, { root: true });
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getPhotoReportById: async({ commit }, photoReport) => {
        return await request({ method: 'get', url: `/request/${photoReport.id}`, params: {
            ...Object.select(photoReport, ['q', 'status', 'brandId', 'endDate', 'startDate', 'page'])
        }})
            .then(res => {
                if (res.data) {
                    commit('SET_PHOTO_REPORT', res.data);
                    commit('SET_PAGINATION', { page: res.data.page, totalPages: res.data.totalPages });
                }
            }).catch(() => {
                router.push('/404');
            });
    },

    changeImage: async({ dispatch, commit }, data) => {
        await request({ method: 'patch', url: `/request/${data.requestDriverId}/${data.typeId}/image`, data: {
            accept: data.accept,
            comment: data.comment
        }})
            .then(res => {
                if (res.data && res.data.image) {
                    commit('SET_DRIVER_STATUS', {
                        driverId: res.data.driverId,
                        status: res.data.status
                    });

                    commit('REMOVE_IMAGE', res.data.image);
                }

                if (res.data.request && res.data.request.status == 'close') {
                    dispatch('alert/addMessage', {
                        message: 'closedPhotoRequest',
                        type: 'success',
                        locale: true
                    }, { root: true });

                    router.push('/photo-report/reports');
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    completePhotoReport: async({ dispatch }, photoReportId) => {
        return await request({ method: 'post', url: `/request/${photoReportId}/complete`})
            .then((res) => {
                router.push('/photo-report/reports');
                dispatch('alert/addMessage', {
                    type: 'success',
                    message: 'success'
                }, { root: true });
                return res;
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    editDriverStatus: async({ state, dispatch }, data) => {
        await request({ method: 'put', url: `/request/driver/${data.requestDriverId}`, data: {
            status: data.status
        }})
            .then(res => {
                if (res.data) {
                    if (res.data.status && ['rejected', 'accepted'].includes(res.data.status)) {
                        const index = state.photoReport.items.findIndex(it => it.requestDriverId == res.data.id);

                        if (index !== -1) {
                            Vue.set(state.photoReport.items[index], 'images', []);
                        }
                    }

                    if (res.data.request && res.data.request.status == 'close') {
                        dispatch('alert/addMessage', {
                            message: 'closedPhotoRequest',
                            type: 'success',
                            locale: true
                        }, { root: true });

                        router.push('/photo-report/reports'); return;
                    }

                    dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'success'
                    }, { root: true });
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    editDriverComment: async({ dispatch }, data) => {
        await request({ method: 'patch', url: `/request/driver/${data.requestDriverId}/comment`, data: {
            comment: data.comment
        }})
            .then(() => {
                dispatch('alert/addMessage', {
                    type: 'success',
                    message: 'success'
                }, { root: true });
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    }
};
